





























import { Vue, Component, Prop } from "vue-property-decorator";
import { screenWidth } from "@/plugins/variables";

@Component({ components: {} })
export default class CustomTableCol extends Vue {
  @Prop() lg!: number;
  @Prop({ default: false }) downloading!: boolean;

  get screenWidth() {
    return screenWidth();
  }
}
